import axiosInstance from 'src/common/axiosInstance';
import { dedupedRequest, clearRequestCache } from 'src/common/requestCache';

const workspaceWhatsappAccountService = {

    index(workspaceId, params = {}) {

        const base = `/workspaces/${workspaceId}/whatsapp-accounts`;
        const key = `${base}?${new URLSearchParams(params).toString()}`;
        return dedupedRequest(key, () =>
            axiosInstance.get(base, { params }),
        );

    },

    show(workspaceId, accountId) {

        return axiosInstance.get(
            `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}`
        );

    },

    create(workspaceId, data) {

        clearRequestCache(`/workspaces/${workspaceId}/whatsapp-accounts`);
        return axiosInstance.post(
            `/workspaces/${workspaceId}/whatsapp-accounts`,
            data
        );

    },

    update(workspaceId, accountId, data) {

        clearRequestCache(`/workspaces/${workspaceId}/whatsapp-accounts`);
        return axiosInstance.put(
            `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}`,
            data
        );

    },

    destroy(workspaceId, accountId) {

        clearRequestCache(`/workspaces/${workspaceId}/whatsapp-accounts`);
        return axiosInstance.delete(
            `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}`
        );

    },

};

export default workspaceWhatsappAccountService;